import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";

import TextField from "@mui/material/TextField";

import styles from "./styles.module.css";

import { alterarSenhaHandler } from "../../services/auth.service";

import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";

import ResponsivContent from "../../components/ResponsivContent";
import { IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import ValidadorSenha from "../../components/ValidadorSenha";


export const EditPassword = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState({
    type: "",
    mensagem: "",
    loading: false,
  });

  const [msg, setMsg] = useState("");

  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const [showPassword, setShowPassword] = useState(false);
  const [senhaCompleta, setSenhaCompleta] = useState(false);
  const [senha, setSenha] = useState("");
  const [confirmaSenha, setConfirmaSenha] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setToken(urlParams.get("token") ?? "");
  }, []);

  const handleChangeSenha = (event) => {
    setSenha(event.target.value);
  };

  const handleChangeConfirmaSenha = (event) => {
    setConfirmaSenha(event.target.value);
  };

  const handleAlterarSenha = async () => {
    if (senha !== confirmaSenha) {
      setMsg("O campo de confirmação não é igual ao campo da senha.");
      handleOpenSnackbarErro();
      return;
    }
    if (!token || !String(token).trim()) {
      setMsg("Token de redefinição não encontrado. Use o link enviado por e-mail.");
      handleOpenSnackbarErro();
      return;
    }

    setStatus({
      loading: true,
    });

    await alterarSenhaHandler(token, { nova_senha: senha })
      .then((response) => {
        setMsg(response.mensagem);
        handleOpenSnackbarSucesso();
        setTimeout(() => {
          navigate("/");
          setStatus({
            loading: false,
          });
        }, 2000);
      })
      .catch((err) => {
        const msgErro = err?.response?.data?.mensagem || err?.message || "Erro ao alterar senha. Tente novamente.";
        setMsg(msgErro);
        handleOpenSnackbarErro();
        setStatus((s) => ({ ...s, loading: false }));
      });
  };

  return (
    <div className={styles.pageContainer}>
      <ResponsivContent>
        <section className={styles.containerSection}>
          <div className={styles.title}>
            <h2>Redefinição de Senha</h2>
          </div>
          <div className={styles.containerSenhaTextField}>
            <label className={styles.labelField}>Nova Senha: </label>
            <OutlinedInput
              className={styles.senhaTextField}
              id="filled-adornment-password"
              type={showPassword ? 'text' : 'password'}
              size="small"
              fullWidth
              value={senha ?? ""}
              onChange={handleChangeSenha}
              name="senha"
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
            <ValidadorSenha senha={senha} setSenhaCompleta={setSenhaCompleta} />
        
            <label className={styles.labelField}>Confirme a Nova Senha: </label>
            <OutlinedInput
              className={styles.senhaTextField}
              id="filled-adornment-password-confirm"
              type={showPassword ? "text" : "password"}
              size="small"
              fullWidth
              value={confirmaSenha ?? ""}
              onChange={handleChangeConfirmaSenha}
              name="senha"
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
            {(confirmaSenha && confirmaSenha !== senha) ? <p style={{color: 'red', fontSize: '.8rem'}}>As senhas devem ser idênticas!</p> : ''}
          </div>

          <div className={styles.container__buttons}>
            <Button
              fullWidth
              type="button"
              disabled={!senhaCompleta || confirmaSenha !== senha || status.loading}
              className={(senhaCompleta && confirmaSenha === senha && !status.loading) ? styles.botaoConfirmar : styles.botaoConfirmar_disable}
              variant="contained"
              onClick={handleAlterarSenha}
            >
              {status.loading ? "Enviando..." : "CONFIRMAR"}
            </Button>
          </div>
        </section>
      </ResponsivContent>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};
